export default __webpack_public_path__ + "assets/img/fontawesome-webfont.20fd1704ea223900efa9fd4e869efb08.woff2";